/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React from 'react';
import { enquireScreen } from 'enquire-js';

import Feature7 from './Feature7';
import Teams4 from './Teams4';
import ZiZhi from "../zizhi"
import Point from './Point';
import { Feature70DataSource, Teams40DataSource } from './data.source';
import './less/antMotionStyle.less';

let isMobile;
enquireScreen((b) => {
  isMobile = b;
});

const { location = {} } = typeof window !== 'undefined' ? window : {};

export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile,
      show: !location.port, // 如果不是 dva 2.0 请删除
    };
  }

  componentDidMount() {
    // 适配手机屏幕;
    enquireScreen((b) => {
      this.setState({ isMobile: !!b });
    });
    // dva 2.0 样式在组件渲染之后动态加载，导致滚动组件不生效；线上不影响；
    /* 如果不是 dva 2.0 请删除 start */
    if (location.port) {
      // 样式 build 时间在 200-300ms 之间;
      setTimeout(() => {
        this.setState({
          show: true,
        });
      }, 500);
    }
    /* 如果不是 dva 2.0 请删除 end */
  }

  render() {
    const children = [
      <Feature7
        id="Feature7_0"
        key="Feature7_0"
     
        dataSource={Feature70DataSource}
        isMobile={this.state.isMobile}
      />,
      <ZiZhi />,
      <Teams4
        id="Teams4_0"
        key="Teams4_0"
        style={{marginTop: '-124px'}}
        dataSource={Teams40DataSource}
        isMobile={this.state.isMobile}
      />, // 导航和页尾不进入锚点区，如果需要，自行添加;
      // <Point
      //   key="list"
      //   data={['Feature7_0', 'Teams4_0']}
      //   stroke="point-stroke"
      //   size="point-small"
      // />,
    ];
    return (
      <div
        className="templates-wrapper"
       
        ref={(d) => {
          this.dom = d;
        }}
      >
        {/* 如果不是 dva 2.0 替换成 {children} start */}
        {this.state.show && children}
        {/* 如果不是 dva 2.0 替换成 {children} end */}
      </div>
    );
  }
}
